import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { TicketingConfigurationTab } from "@/pages/IntegrationsPage/components/organisms/TicketingConfigurationTab"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"

export const JiraConfigurationPage = () => (
  <ConfigurationPageTemplate
    vendor={INTEGRATION_VENDORS.jira}
    config={<TicketingConfigurationTab vendor={INTEGRATION_VENDORS.jira} />}
    titleKey="integrations.configuration.jira.configurationTitle"
  />
)
